"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.defaultOptions = exports.RestrictionError = exports.Restricter = void 0;
var _prettierBytes = _interopRequireDefault(require("@transloadit/prettier-bytes"));
var _mimeMatch = _interopRequireDefault(require("mime-match"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); } /* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-classes-per-file, class-methods-use-this */ // @ts-ignore untyped
/**
 * The minimal required properties to be present from UppyFile in order to validate it.
 */

var defaultOptions = exports.defaultOptions = {
  maxFileSize: null,
  minFileSize: null,
  maxTotalFileSize: null,
  maxNumberOfFiles: null,
  minNumberOfFiles: null,
  allowedFileTypes: null,
  requiredMetaFields: []
};
var RestrictionError = exports.RestrictionError = /*#__PURE__*/function (_Error) {
  function RestrictionError(message, opts) {
    var _this;
    _classCallCheck(this, RestrictionError);
    var _opts$isUserFacing;
    _this = _callSuper(this, RestrictionError, [message]);
    _this.isRestriction = true;
    _this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
    if (opts != null && opts.file) {
      _this.file = opts.file; // only some restriction errors are related to a particular file
    }
    return _this;
  }
  _inherits(RestrictionError, _Error);
  return _createClass(RestrictionError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var Restricter = exports.Restricter = /*#__PURE__*/function () {
  function Restricter(getOpts, getI18n) {
    _classCallCheck(this, Restricter);
    this.getI18n = getI18n;
    this.getOpts = function () {
      var _opts$restrictions;
      var opts = getOpts();
      if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) {
        throw new TypeError('`restrictions.allowedFileTypes` must be an array');
      }
      return opts;
    };
  }

  // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
  return _createClass(Restricter, [{
    key: "validateAggregateRestrictions",
    value: function validateAggregateRestrictions(existingFiles, addingFiles) {
      var _this$getOpts$restric = this.getOpts().restrictions,
        maxTotalFileSize = _this$getOpts$restric.maxTotalFileSize,
        maxNumberOfFiles = _this$getOpts$restric.maxNumberOfFiles;
      if (maxNumberOfFiles) {
        var nonGhostFiles = existingFiles.filter(function (f) {
          return !f.isGhost;
        });
        if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) {
          throw new RestrictionError("".concat(this.getI18n()('youCanOnlyUploadX', {
            smart_count: maxNumberOfFiles
          })));
        }
      }
      if (maxTotalFileSize) {
        var totalFilesSize = [].concat(_toConsumableArray(existingFiles), _toConsumableArray(addingFiles)).reduce(function (total, f) {
          var _f$size;
          return total + ((_f$size = f.size) != null ? _f$size : 0);
        }, 0);
        if (totalFilesSize > maxTotalFileSize) {
          throw new RestrictionError(this.getI18n()('aggregateExceedsSize', {
            sizeAllowed: (0, _prettierBytes.default)(maxTotalFileSize),
            size: (0, _prettierBytes.default)(totalFilesSize)
          }));
        }
      }
    }
  }, {
    key: "validateSingleFile",
    value: function validateSingleFile(file) {
      var _this$getOpts$restric2 = this.getOpts().restrictions,
        maxFileSize = _this$getOpts$restric2.maxFileSize,
        minFileSize = _this$getOpts$restric2.minFileSize,
        allowedFileTypes = _this$getOpts$restric2.allowedFileTypes;
      if (allowedFileTypes) {
        var isCorrectFileType = allowedFileTypes.some(function (type) {
          // check if this is a mime-type
          if (type.includes('/')) {
            if (!file.type) return false;
            return (0, _mimeMatch.default)(file.type.replace(/;.*?$/, ''), type);
          }

          // otherwise this is likely an extension
          if (type[0] === '.' && file.extension) {
            return file.extension.toLowerCase() === type.slice(1).toLowerCase();
          }
          return false;
        });
        if (!isCorrectFileType) {
          var allowedFileTypesString = allowedFileTypes.join(', ');
          throw new RestrictionError(this.getI18n()('youCanOnlyUploadFileTypes', {
            types: allowedFileTypesString
          }), {
            file: file
          });
        }
      }

      // We can't check maxFileSize if the size is unknown.
      if (maxFileSize && file.size != null && file.size > maxFileSize) {
        throw new RestrictionError(this.getI18n()('exceedsSize', {
          size: (0, _prettierBytes.default)(maxFileSize),
          file: file.name
        }), {
          file: file
        });
      }

      // We can't check minFileSize if the size is unknown.
      if (minFileSize && file.size != null && file.size < minFileSize) {
        throw new RestrictionError(this.getI18n()('inferiorSize', {
          size: (0, _prettierBytes.default)(minFileSize)
        }), {
          file: file
        });
      }
    }
  }, {
    key: "validate",
    value: function validate(existingFiles, addingFiles) {
      var _this2 = this;
      addingFiles.forEach(function (addingFile) {
        _this2.validateSingleFile(addingFile);
      });
      this.validateAggregateRestrictions(existingFiles, addingFiles);
    }
  }, {
    key: "validateMinNumberOfFiles",
    value: function validateMinNumberOfFiles(files) {
      var minNumberOfFiles = this.getOpts().restrictions.minNumberOfFiles;
      if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) {
        throw new RestrictionError(this.getI18n()('youHaveToAtLeastSelectX', {
          smart_count: minNumberOfFiles
        }));
      }
    }
  }, {
    key: "getMissingRequiredMetaFields",
    value: function getMissingRequiredMetaFields(file) {
      var error = new RestrictionError(this.getI18n()('missingRequiredMetaFieldOnFile', {
        fileName: file.name
      }));
      var requiredMetaFields = this.getOpts().restrictions.requiredMetaFields;
      var missingFields = [];
      var _iterator = _createForOfIteratorHelper(requiredMetaFields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          if (!Object.hasOwn(file.meta, field) || file.meta[field] === '') {
            missingFields.push(field);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        missingFields: missingFields,
        error: error
      };
    }
  }]);
}();